# Строки Vue-страниц и компонентов (app/frontend/lib/i18n.js → t("auth.sign_in.title")).
# Синтаксис как у Rails: %{name} — подстановка; для count — формы one/few/many/other.
# Серверные сообщения (flash, ошибки валидации) — в ru.yml и devise.ru.yml.
ru:
  frontend:
    common:
      email: "E-mail"
      password: "Пароль"
      save: "Сохранить"
      sign_in: "Войти"
      sign_out: "Выйти"
      back: "← Назад"
      next: "Дальше →"
      home: "На главную"
      none: "—"
      cancel: "Отмена"
    ui:
      close: "Закрыть"
      more_actions: "Ещё действия"
    theme:
      label: "Тема оформления"
      system: "Как в системе"
      light: "Светлая"
      dark: "Тёмная"
    toast:
      close: "Закрыть"
      region: "Уведомления"
    legal_links:
      label: "Документы"
    captcha:
      language: "ru"
    error_page:
      title: "Ошибка %{status}"
      "403":
        title: "Доступ закрыт"
        text: "У вас нет прав на эту страницу."
      "404":
        title: "Страница не найдена"
        text: "Возможно, она была удалена или в адресе опечатка."
      "422":
        title: "Запрос отклонён"
        text: "Скорее всего, страница устарела. Обновите её и попробуйте ещё раз."
      "429":
        title: "Слишком много запросов"
        text: "Подождите немного и попробуйте снова."
      "500":
        title: "Что-то пошло не так"
        text: "Мы уже знаем об ошибке и разбираемся. Попробуйте чуть позже."
      "503":
        title: "Сервис временно недоступен"
        text: "Идут технические работы. Попробуйте через несколько минут."
    dashboard_layout:
      nav_dashboard: "Личный кабинет"
      nav_profile: "Профиль"
      signed_in_as: "Вы вошли как %{email}"
    dashboard:
      title: "Личный кабинет"
      lead: "Вы вошли как %{email}."
      empty: "Здесь появится содержимое личного кабинета."
      new_calendar: "Новый макет"
    auth:
      sign_in:
        title: "Вход"
        remember_me: "Запомнить меня"
        forgot_password: "Забыли пароль?"
        sign_up: "Создать аккаунт"
      sign_up:
        title: "Регистрация"
        password_hint: "Минимум 6 символов"
        password_confirmation: "Повторите пароль"
        consent_before: "Даю"
        consent_link: "согласие на обработку персональных данных"
        marketing_before: "Хочу получать"
        marketing_link: "новости и предложения"
        marketing_after: "на e-mail"
        submit: "Создать аккаунт"
        terms_before: "Создавая аккаунт, вы принимаете"
        terms_link: "Пользовательское соглашение"
        terms_and: "и"
        privacy_link: "Политику обработки персональных данных"
        have_account: "Уже есть аккаунт? Войти"
      forgot_password:
        title: "Восстановление пароля"
        email_hint: "Пришлём ссылку для сброса пароля"
        submit: "Отправить инструкции"
        back_to_sign_in: "Вернуться ко входу"
      reset_password:
        title: "Новый пароль"
        password: "Новый пароль"
        password_hint: "Минимум 6 символов"
        password_confirmation: "Повторите пароль"
        submit: "Сохранить пароль"
      profile:
        title: "Профиль"
        new_password: "Новый пароль"
        new_password_hint: "Оставьте пустым, если не меняете пароль"
        new_password_confirmation: "Повторите новый пароль"
        current_password: "Текущий пароль"
        current_password_hint: "Нужен для подтверждения любых изменений"
        marketing_title: "Рассылки"
        marketing_on: "Вы получаете новости и предложения на e-mail."
        marketing_off: "Вы не подписаны на новости и предложения."
        unsubscribe: "Отписаться"
        subscribe: "Подписаться"
        delete_title: "Удаление аккаунта"
        delete_text: >-
          Аккаунт и все связанные с ним данные будут удалены — это также отзыв согласия на
          обработку персональных данных. Восстановить аккаунт будет нельзя.
        delete_password: "Пароль для подтверждения удаления"
        delete_submit: "Удалить аккаунт"
        delete_confirm_title: "Удалить аккаунт?"
        delete_confirm: "Удалить аккаунт и все данные без возможности восстановления?"
    legal:
      back: "← На главную"
      draft: "Черновик: реквизиты оператора не заполнены (админка → «Юридическое»). Не публиковать в таком виде."
      edition: "Редакция %{version} от %{date}"
    admin:
      layout:
        title_suffix: "Админка"
        badge: "Администрирование"
        nav_users: "Пользователи"
        nav_settings: "Настройки"
        nav_legal: "Юридическое"
        nav_icons: "Иконки"
        nav_calendar_themes: "Темы календаря"
        nav_tariffs: "Тарифы"
        nav_design_tokens: "Дизайн-токены"
        nav_components: "Компоненты"
        signed_in_as: "Администратор %{email}"
      sign_in:
        title: "Вход в админку"
      users:
        title: "Пользователи"
        search: "Поиск по e-mail"
        search_submit: "Найти"
        email: "E-mail"
        registered: "Зарегистрирован"
        status: "Статус"
        not_found: "Никого не нашлось."
        empty: "Пользователей пока нет."
        page: "Страница %{page}"
      user:
        back: "← Все пользователи"
        registered: "Зарегистрирован"
        status: "Статус"
        unblock: "Разблокировать"
        block: "Заблокировать"
        delete: "Удалить"
        block_confirm_title: "Заблокировать пользователя?"
        delete_confirm_title: "Удалить пользователя?"
        block_confirm: "Заблокировать %{email}? Пользователь не сможет войти, пока его не разблокируют."
        delete_confirm: "Удалить %{email} со всеми данными? Восстановить будет нельзя."
        consents_title: "Журнал согласий"
        consent_document: "Документ"
        consent_version: "Редакция"
        consent_given: "Дано"
        consent_ip: "IP"
        consent_withdrawn: "Отозвано"
        consents_empty: "Записей нет."
      settings:
        title: "Настройки"
        registration: "Регистрация открыта"
        registration_hint: "Если выключить, новые пользователи не смогут создать аккаунт. Вход и профиль работают как обычно."
        captcha: "Капча на регистрации и восстановлении пароля"
        captcha_hint: "Yandex SmartCaptcha."
        captcha_not_configured: "Не заданы ключи SMARTCAPTCHA_CLIENT_KEY и SMARTCAPTCHA_SERVER_KEY — пока их нет, капча не показывается, даже если включена."
      legal:
        title: "Юридическое"
        draft: "Реквизиты не заполнены — на страницах документов висит пометка «Черновик». Заполните все поля ниже."
        intro: >-
          Эти данные подставляются в тексты документов. После сохранения изменений у всех
          документов публикуется новая редакция — её номер попадает в журнал согласий
          пользователей. Сами тексты меняются в коде (app/views/legal/).
        operator: "Оператор персональных данных"
        operator_kind: "Кто владелец сайта"
        kinds:
          company: "Организация (ООО, АО)"
          entrepreneur: "Индивидуальный предприниматель"
          self_employed: "Самозанятый (без ИП)"
        name_hints:
          company: "Полное название: ООО «Ромашка»"
          entrepreneur: "Индивидуальный предприниматель Иванов Иван Иванович"
          self_employed: "Фамилия, имя, отчество полностью"
        self_employed_note: >-
          Для самозанятого на сайте публикуются только ФИО, ИНН, статус плательщика налога на
          профессиональный доход и e-mail. Адрес не публикуется, в уведомлении Роскомнадзора он
          указывается отдельно.
        full_name: "ФИО"
        name: "Название"
        inn: "ИНН"
        ogrn: "ОГРН"
        ogrnip: "ОГРНИП"
        address: "Адрес"
        address_company: "Юридический адрес"
        address_entrepreneur: "Адрес регистрации ИП"
        operator_email: "E-mail для запросов по персональным данным"
        site_url: "Адрес сайта"
        documents: "Документы"
        marketing: "Рекламные рассылки"
        marketing_hint: "Отдельное согласие на рассылки при регистрации и переключатель в профиле (ст. 18 38-ФЗ)."
        paid: "Платный сервис"
        paid_hint: "Публикуется публичная оферта — разделы о тарифах и оплате в тексте нужно заполнить."
        retention: "Сроки хранения, дней"
        retention_after_deletion: "После удаления аккаунта"
        retention_after_deletion_hint: "Не больше 30 (ст. 21 152-ФЗ)"
        retention_backups: "Резервные копии"
        retention_backups_hint: "Как в настройке бэкапов"
        retention_logs: "Логи сервера"
        retention_logs_hint: "Как в ротации логов"
        published: "Опубликованные документы"
        history: "История редакций"
        document: "Документ"
        version: "Редакция"
        date: "От"
        reason: "Причина"

      icons:
        title: "Иконки событий"
        lead: "Набор для событий в конструкторе: Tabler Icons %{version}. Только просмотр — набор меняется в коде (config/event_icons.yml)."
        color: "Цвет клетки"
        count:
          one: "%{count} иконка"
          few: "%{count} иконки"
          many: "%{count} иконок"
          other: "%{count} иконки"
        hidden_title: "Скрытые"
        hidden_hint: "Не предлагаются в конструкторе, но рисуются в уже созданных макетах."
        hidden_empty: "Скрытых иконок нет."
      calendar_themes:
        title: "Темы календаря"
        lead: "Темы листа и печатные цвета: у каждого цвета пара RGB (экран) и CMYK (печать). Только просмотр — темы меняются сидами, остальные цвета — в config/print_colors.yml."
        hidden: "Скрыта"
        calendars_count:
          one: "%{count} макет"
          few: "%{count} макета"
          many: "%{count} макетов"
          other: "%{count} макета"
        event_colors: "Цвета событий"
        sheet_colors: "Постоянные цвета листа"
        cmyk: "CMYK %{c} / %{m} / %{y} / %{k}"
      tariffs:
        title: "Тарифы"
        lead: "Цена макета задаётся основным тарифом и не зависит от размера листа. Новая цена действует для следующих оплат. Набор функций и сами тарифы меняются в коде."
        name: "Название"
        price: "Цена"
        price_rub: "Цена, ₽"
        price_hint: "Целое число рублей, от 1 до 100 000."
        features_title: "Функции"
        main: "Основной"
        edit: "Изменить"
        edit_title: "Тариф «%{name}»"
        features:
          size_a4: "Размер A4"
          size_a3: "Размер A3"
          size_a2: "Размер A2"
          size_a1: "Размер A1"
          size_a0: "Размер A0"
          themes: "Темы календаря"
          seasons: "Границы сезонов"
          events: "События"
          slogan: "Слоган"
          decoration: "Графика у слогана"
          custom_text: "Свой текст"
          grid: "Сетка: форма клеток и линия"
          header_color: "Цвет шапки и подвала"
      design_tokens:
        title: "Дизайн-токены"
        lead: "Токены дизайн-системы «Веб-сервис» из tokens.css — значения текущей темы. Только просмотр: токены меняются в коде."
        brand: "Палитра бренда"
        semantic: "Цвета темы"
        type: "Шкала кеглей · Manrope"
        num: "Числа · Oswald 600"
        sample: "Живи этим или брось это!"
        utilities: "Утилиты Tailwind"
        shadows: "Тени"
        radii: "Радиусы"
        spacing: "Отступы"
      components:
        title: "Компоненты"
        lead: "UI-компоненты дизайн-системы «Веб-сервис» во всех вариантах и состояниях. Только просмотр: тема — переключателем в меню."
        buttons: "Кнопки"
        fields: "Поля и формы"
        chips: "Статусы"
        switches: "Переключатели"
        segmented: "Сегменты"
        modals: "Окна"
        toasts: "Уведомления"
        tooltip: "Подсказка"
        action_menu: "Меню действий"
        table: "Таблица"
        hover: "hover"
        primary: "Оплатить и скачать"
        secondary: "Сохранить черновик"
        ghost: "Отменить"
        danger: "Удалить"
        danger_solid: "Удалить навсегда"
        small: "Продолжить"
        unavailable: "Недоступно"
        event_name: "Название события"
        event_placeholder: "Например, «10 лет»"
        event_hint: "Отображается в клетке под иконкой"
        start_date: "Дата начала"
        promo: "Промокод"
        promo_error: "Код не найден — проверьте написание"
        print_format: "Формат печати"
        print_format_later: "A2 — выбирается на следующем шаге"
        calendar_type: "Тип календаря"
        type_year: "Год · 1 января — 31 декабря"
        type_365: "365 · с любой даты"
        segment_year: "Год"
        theme: "Тема оформления"
        theme_disabled_hint: "Других тем пока нет"
        sheet_theme_seasonal: "Сезонная"
        sheet_theme_eco: "Эко"
        chip_draft: "Черновик"
        chip_pending: "Ожидает оплаты"
        chip_paid: "Оплачен"
        chip_printing: "Готовится PDF"
        chip_cancelled: "Отменён"
        chip_soon: "Скоро"
        switch_years: "Полоса годов"
        switch_today: "Подсветка сегодня"
        switch_tail: "Серый хвост месяца"
        switch_disabled: "Недоступно на A4"
        filter: "Фильтр макетов"
        filter_all: "Все"
        filter_drafts: "Черновики"
        filter_paid: "Оплаченные"
        theme_light: "Светлая тема"
        theme_dark: "Тёмная тема"
        open_small: "Окно 360"
        open_wide: "Окно 520"
        open_confirm: "Подтверждение удаления"
        modal_title: "Скачать PDF?"
        modal_text: "Календарь «SandDays · 2027» готов к печати в формате A2. Файл будет доступен в личном кабинете ещё 12 месяцев."
        modal_wide_title: "Оплата макета"
        modal_wide_text: "Широкое окно для содержимого: сводка заказа, предупреждение о блокировке оплаченного макета и кнопка оплаты. На узком экране окно становится шторкой — потяните её вниз, чтобы закрыть."
        modal_download: "Скачать PDF"
        modal_pay: "Оплатить 299 ₽"
        confirm_title: "Удалить макет?"
        confirm_text: "Черновик «Год 2027» удалится без возможности восстановления."
        toast_notice: "Показать успех"
        toast_alert: "Показать ошибку"
        toast_notice_text: "PDF сохранён в личном кабинете"
        toast_alert_text: "Не удалось сохранить черновик — попробуйте ещё раз"
        tooltip_text: "Списано 299 ₽ · 14.09.2026"
        soon_item: "Онлайн-календарь"
        soon_tooltip: "Скоро: раздел появится позже"
        continue: "Продолжить"
        menu_pay: "Оплатить"
        menu_delete: "Удалить"
        menu_chosen: "Выбран пункт «%{item}»"
        col_order: "Заказ"
        col_date: "Дата"
        col_format: "Формат"
        col_status: "Статус"
        col_sum: "Сумма"
        order_year: "SandDays · Год 2027"
        order_365: "SandDays · 365 (с 01.10)"
    event_icons:
      categories:
        holidays: "Праздники"
        love: "Любовь"
        family: "Семья и дети"
        travel: "Путешествия"
        nature: "Природа и погода"
        home_work: "Дом и работа"
        health: "Здоровье и спорт"
        hobby: "Хобби"
        food: "Еда"
      names:
        gift: "Подарок"
        cake: "Торт"
        balloon: "Шарик"
        tree: "Ёлка"
        star: "Звезда"
        music: "Музыка"
        confetti: "Конфетти"
        candle: "Свеча"
        champagne: "Шампанское"
        egg: "Яйцо"
        pumpkin: "Тыква"
        snowman: "Снеговик"
        masks: "Маски"
        candy: "Конфета"
        flag: "Флаг"
        heart: "Сердце"
        flower: "Цветок"
        smile: "Улыбка"
        mood_heart: "Влюблённость"
        heart_handshake: "Поддержка"
        hearts: "Сердца"
        mail_heart: "Письмо с сердцем"
        infinity: "Бесконечность"
        diamond: "Бриллиант"
        union: "Союз"
        baby_carriage: "Коляска"
        baby_bottle: "Бутылочка"
        kid: "Ребёнок"
        boy: "Мальчик"
        man: "Мужчина"
        woman: "Женщина"
        users: "Семья"
        friends: "Друзья"
        paw: "Лапа"
        dog: "Собака"
        cat: "Кошка"
        backpack: "Рюкзак"
        horse_toy: "Лошадка"
        plane: "Самолёт"
        sun: "Солнце"
        mountain: "Горы"
        suitcase: "Чемодан"
        camera: "Фото"
        beach: "Пляж"
        map_pin: "Место"
        compass: "Компас"
        tent: "Палатка"
        car: "Машина"
        train: "Поезд"
        ship: "Корабль"
        world: "Мир"
        map: "Карта"
        ticket: "Билет"
        campfire: "Костёр"
        leaf: "Лист"
        trees: "Лес"
        cloud: "Облако"
        cloud_rain: "Дождь"
        snowflake: "Снежинка"
        umbrella: "Зонт"
        moon: "Луна"
        rainbow: "Радуга"
        plant: "Растение"
        seedling: "Росток"
        butterfly: "Бабочка"
        fish: "Рыба"
        potted_plant: "Комнатное растение"
        home: "Дом"
        briefcase: "Работа"
        book: "Книга"
        cap: "Учёба"
        coffee: "Кофе"
        building: "Офис"
        calendar: "Календарь"
        laptop: "Ноутбук"
        key: "Ключ"
        truck: "Переезд"
        tools: "Ремонт"
        piggy_bank: "Копилка"
        shopping_bag: "Покупки"
        dumbbell: "Спорт"
        bike: "Велосипед"
        pulse: "Здоровье"
        run: "Бег"
        swimming: "Плавание"
        yoga: "Йога"
        stethoscope: "Врач"
        vaccine: "Прививка"
        football: "Футбол"
        basketball: "Баскетбол"
        first_aid: "Аптечка"
        trophy: "Кубок"
        medal: "Медаль"
        target: "Цель"
        microphone: "Микрофон"
        headphones: "Наушники"
        movie: "Кино"
        gamepad: "Игры"
        chess: "Шахматы"
        sewing: "Шитьё"
        books: "Чтение"
        palette: "Рисование"
        brush: "Кисть"
        puzzle: "Пазл"
        fishing: "Рыбалка"
        tennis: "Теннис"
        paint_roller: "Покраска"
        pizza: "Пицца"
        salad: "Салат"
        soup: "Суп"
        ice_cream: "Мороженое"
        wine: "Вино"
        beer: "Пиво"
        cutlery: "Ресторан"
        burger: "Бургер"
        carrot: "Морковь"
        apple: "Яблоко"
    calendar:
      weekdays_short: ["ПН", "ВТ", "СР", "ЧТ", "ПТ", "СБ", "ВС"]
      months_short: ["ЯНВ", "ФЕВ", "МАР", "АПР", "МАЙ", "ИЮН", "ИЮЛ", "АВГ", "СЕН", "ОКТ", "НОЯ", "ДЕК"]
      months_genitive: ["января", "февраля", "марта", "апреля", "мая", "июня", "июля", "августа", "сентября", "октября", "ноября", "декабря"]
      seasons:
        winter: "Зима"
        spring: "Весна"
        summer: "Лето"
        autumn: "Осень"
      sheet:
        logo_accent: "SAND"
        logo_rest: "DAYS"
        site: "SANDDAYS.RU"
        type_year: "Календарь на год · %{year}"
        type_days365: "Календарь 365 · с %{date}"
        period_year: "1 января — 31 декабря %{year}"
        period: "%{start} — %{end}"
        date: "%{day} %{month} %{year}"
        size: "%{size} · %{width} × %{height} мм"
      decorations:
        none: "Без графики"
        hourglass: "Песочные часы"
        tree: "Дерево"
        rocket: "Ракета"
        mountain: "Горы"
        sun: "Солнце"
        compass: "Компас"
        sailboat: "Парусник"
        paperplane: "Бумажный самолётик"
        owl: "Сова"
    orders:
      checking:
        title: "Проверяем оплату…"
        text: "Это займёт несколько секунд."
      paid:
        title: "Оплата прошла"
        text: "Готовим файл — обычно несколько минут, пришлём письмо на %{email}."
      processing:
        title: "Платёж обрабатывается"
        text: "Как только Robokassa его подтвердит, макет станет оплаченным в «Моих макетах»."
      expired:
        title: "Оплата не поступила"
        text: "Счёт истёк, деньги не списаны. Вернитесь к макету, чтобы оплатить ещё раз."
      dashboard: "Мои макеты"
      open: "Открыть макет"
      back: "Вернуться к макету"
    constructor:
      months_abbr: ["янв", "фев", "мар", "апр", "мая", "июн", "июл", "авг", "сен", "окт", "ноя", "дек"]
      months: ["Январь", "Февраль", "Март", "Апрель", "Май", "Июнь", "Июль", "Август", "Сентябрь", "Октябрь", "Ноябрь", "Декабрь"]
      months_initial: ["Я", "Ф", "М", "А", "М", "И", "И", "А", "С", "О", "Н", "Д"]
      save:
        browser: "Сохранено в браузере"
        sign_in: "Войти, чтобы сохранить в аккаунте"
        saving: "Сохраняем…"
        saved: "Сохранено · %{time}"
        just_now: "только что"
        offline: "Не сохранено · нет соединения"
        rejected: "Не удалось сохранить"
        short:
          browser: "В браузере"
          saved: "Сохранено"
          offline: "Нет соединения"
          rejected: "Не сохранено"
        drafts_limit: "Достигнут лимит — 50 черновиков. Удалите лишние в «Моих макетах», чтобы начать новый."
        claim_limit: "Достигнут лимит — 50 черновиков. Удалите лишние в «Моих макетах» — и черновик сохранится в аккаунт."
      leave:
        saving_title: "Сохраняем изменения…"
        saving_text: "Ещё секунду — и вернёмся в «Мои макеты». Ничего делать не нужно."
        fail_title: "Не удалось сохранить изменения"
        fail_offline: "Пропало соединение. Если выйти сейчас, последние правки макета могут потеряться."
        fail_rejected: "Сервер не принял изменения. Если выйти сейчас, последние правки макета потеряются."
        stay: "Остаться в конструкторе"
        exit: "Выйти без сохранения"
        retry: "Повторить"
        toast: "Переходим в «Мои макеты»…"
      topbar:
        home: "SandDays — в личный кабинет"
        back: "Мои макеты"
        back_short: "Макеты"
        nav: "Навигация"
        name: "Название макета"
        draft: "Черновик"
        paid: "Оплачен"
        total: "Итого"
        paid_total: "Оплачено"
        paid_total_price: "Оплачено · %{price}"
        save_pdf: "Сохранить в PDF"
        save_pdf_price: "Сохранить в PDF · %{price}"
      payment:
        title: "Сохранить в PDF"
        type: "Календарь"
        period_year: "Год %{year}"
        period_365: "365 · с %{date}"
        size: "Размер листа"
        theme: "Тема"
        copy_note: "После оплаты макет фиксируется для печати. Изменить его можно в копии, но каждый новый PDF оплачивается отдельно."
        offer_before: "Нажимая «Оплатить», вы принимаете условия"
        offer_link: "оферты"
        captions:
          one: "%{count} подпись не помещается на %{size} — сократите её или выберите размер больше"
          few: "%{count} подписи не помещаются на %{size} — сократите их или выберите размер больше"
          many: "%{count} подписей не помещаются на %{size} — сократите их или выберите размер больше"
          other: "%{count} подписи не помещаются на %{size} — сократите их или выберите размер больше"
        show: "Показать"
        cancel: "Отмена"
        pay: "Оплатить %{price}"
        busy: "Готовим оплату…"
        unavailable: "Оплата временно недоступна"
        save_failed: "Не удалось сохранить макет, оплата невозможна. Попробуйте ещё раз"
        network: "Не удалось связаться с сервером. Проверьте интернет и попробуйте ещё раз"
      auth:
        title: "Войдите, чтобы сохранить PDF"
        lead: "Макет сохранится в вашем аккаунте — к нему и к файлу можно будет вернуться в любой момент."
        tab_sign_in: "Вход"
        tab_sign_up: "Регистрация"
        network: "Не удалось связаться с сервером. Проверьте интернет и попробуйте ещё раз"
      sheet:
        tabs: "Шаги макета"
        expand: "Развернуть настройки"
        collapse: "Свернуть настройки"
      steps:
        type: "Тип"
        theme: "Тема"
        seasons: "Сезоны"
        blocks: "Блоки"
        size: "Размер"
        events: "События"
      summary:
        year: "Год · %{year}"
        days365: "365 · с %{date}"
        seasons: "4 границы"
        blocks: "%{count} из 3 · %{decoration}"
        no_icon: "без иконки"
        size: "%{size} · до %{limit}"
        events:
          one: "%{count} событие"
          few: "%{count} события"
          many: "%{count} событий"
          other: "%{count} события"
      weekdays_short: ["пн", "вт", "ср", "чт", "пт", "сб", "вс"]
      weekdays: ["Понедельник", "Вторник", "Среда", "Четверг", "Пятница", "Суббота", "Воскресенье"]
      day: "%{day} %{month}"
      type:
        label: "Тип календаря"
        year: "Год"
        days365: "365"
        year_hint: "Календарный год: с 1 января по 31 декабря, %{days} дн."
        year_label: "Год"
        prev_year: "Предыдущий год"
        next_year: "Следующий год"
        days365_hint: "365 дней подряд, начиная с выбранной даты. Выберите стартовый день."
        prev_month: "Предыдущий месяц"
        next_month: "Следующий месяц"
        start: "Старт"
        finish: "Финиш"
      theme:
        hint: "Тема задаёт цвета будних и выходных дней по сезонам."
        header: "Шапка и подвал"
        header_light: "Светлые"
        header_dark: "Тёмные"
        grid: "Фон сетки"
        grid_light: "Белый"
        grid_dark: "Тёмный"
        seam: "Разделительные линии"
        seam_hairline: "Тонкая"
        seam_thin: "Средняя"
        seam_medium: "Толстая"
        cells: "Ячейки"
        cells_rounded: "Скруглённые"
        cells_sharp: "Острые"
      seasons:
        hint: "Потяните границы, чтобы сдвинуть начало сезона. Цвета клеток на листе обновятся сразу."
        handles: ["Зима → весна", "Весна → лето", "Лето → осень", "Осень → зима"]
        handle: "%{name}: %{date}"
        range: "с %{from} по %{to}"
        days: "%{count} дн."
        reset: "Сбросить по месяцам"
      blocks:
        slogan: "Слоган"
        slogan_hint: "Справа вверху листа"
        custom: "Подпись"
        custom_hint: "По центру внизу листа"
        decoration: "Иконка"
        decoration_hint: "Справа от логотипа"
        decoration_style: "Стиль иконки"
        style_line: "Линия"
        style_watercolor: "Акварель"
      text:
        slogan: "Свой слоган"
        slogan_hint: "Перенос строки (Enter) попадёт на лист — до %{count} строк."
        slogan_overflow: "Не помещается в шапку: на листе больше %{count} строк, конец обрезан. Сократите длинную строку или уберите перенос."
        presets: "Готовые варианты"
        custom: "Текст подписи"
      size:
        label: "Размер листа"
        limit: "до %{limit}"
        # Жирные части (формат, лимит) подставляет шаблон между фразами — без v-html.
        info_format: "Формат"
        info_dims: "· %{width} × %{height} мм."
        info_caption: "Подпись события — до"
        info_chars: "символов. Чем меньше лист, тем короче подпись: при смене размера мы проверим все события."
        badge: "Подписи не помещаются: %{count}"
        warning_title: "Не поместятся подписи: %{count}"
        warning_text: "На формате %{size} лимит — %{limit} символов. Сократите подписи или выберите формат побольше."
        warning_more: "и ещё %{count}"
        warning_show: "Показать"
      onboarding:
        title: "С чего начать"
        text: "Выберите тип и кликните по любому дню, чтобы отметить событие"
        touch_text: "Тапните по дню, чтобы отметить событие. Для точности приблизьте лист."
        hide: "Скрыть подсказку"
      tooltip: "%{weekday}, %{date}"
      popover:
        new: "%{weekday} · новое событие"
        edit: "%{weekday} · редактирование события"
        close: "Закрыть"
        icon_search: "Найти значок"
        all: "Все"
        categories: "Категории значков"
        icons: "Значки"
        no_icons: "Ничего не найдено. Попробуйте другое слово."
        color: "Цвет"
        caption: "Подпись"
        caption_placeholder: "Например, День рождения Маши"
        over: "Не поместится на %{size}: максимум %{limit} символов."
        delete: "Удалить"
        save: "Сохранить"
      events:
        search: "Поиск по дате или подписи"
        filters: "Фильтр событий"
        all: "Все"
        over: "Не помещаются"
        no_caption: "Без подписи"
        outside: "нет в периоде"
        show: "Показать на листе"
        edit: "Изменить подпись"
        delete: "Удалить событие"
        save: "Сохранить"
        cancel: "Отмена"
        caption: "Подпись"
        empty: "Пока нет отмеченных дат. Кликните по дню на листе."
        empty_touch: "Пока нет отмеченных дат. Тапните по дню на листе."
        not_found: "Ничего не найдено."
      preview:
        chip_year: "%{size} · %{width} × %{height} мм · год %{year}"
        chip_days365: "%{size} · %{width} × %{height} мм · 365 дней"
        backdrop: "Фон"
        backdrops:
          sand: "Песок"
          sage: "Шалфей"
          light: "Светлый"
          kraft: "Крафт"
          graphite: "Графит"
        zoom_out: "Уменьшить"
        zoom_in: "Увеличить"
        fit: "По размеру"
        fit_all: "Показать весь лист"
        actual: "100%"
        drag: "Тяните лист"
        zoom: "Масштаб"
    event_colors:
      birthday: "День рождения"
      anniversary: "Годовщина"
      holiday: "Праздник"
      personal: "Личное"
      milestone: "Веха"
      classic: "Классика"
